// extracted by mini-css-extract-plugin
export default {"shop-bikes":"ShopBikesSection_shop-bikes__J1mQj","header":"ShopBikesSection_header__NL+pW","container":"ShopBikesSection_container__3az9W"};